
import React, {FunctionComponent} from 'react';
import { Input as AInput} from 'antd';
import classnames from 'classnames';
import StylesType from '@/types/StylesType';
import { InputProps as AInputProps  } from 'antd/lib/input';
import './style';

export interface InputProps extends AInputProps{
    status?: 'normal' | 'hover' | 'active' | 'success' | 'error';
}

export const Input: FunctionComponent<StylesType&InputProps> = props => {
  
    const { prefixCls = 'gc-input', status, className, size, disabled} = props;
  
    return <AInput {...props} className={classnames(prefixCls,{[`${prefixCls}-${status}`]: !disabled},`${prefixCls}-${size}`, className)}/>
  
}

Input.defaultProps = {
    size: 'default',
    status: 'normal'
}

export default Input;
